import { Dispatch, SetStateAction, FC, useMemo, memo } from 'react'

import { Divider, HStack, Stack, Tag, TagLabel, Text } from '@chakra-ui/react'

import { RefreshButton } from 'components'
import { FREQUENCIE_ACTIVITIES_TYPES_INITIAL_FILTER } from '../../constants'

export type Props = {
  filter: any
  setFilter: Dispatch<SetStateAction<any>>
  onClose: () => void
}

FREQUENCIE_ACTIVITIES_TYPES_INITIAL_FILTER
const FrequencieActivitiesTypesFilterTemplate: FC<Props> = ({ filter, setFilter, onClose }) => {
  const hasFrequenciesActivitiesTypesOnFilter = useMemo(() => {
    return filter.has_activities_types.length > 0 || filter.not_has_activities_types.length > 0
  }, [filter])

  function resetMetadataFilter() {
    setFilter({ ...filter, ...FREQUENCIE_ACTIVITIES_TYPES_INITIAL_FILTER })
    onClose()
  }

  if (!hasFrequenciesActivitiesTypesOnFilter) return null

  return (
    <Stack px={4} pb={4}>
      <Stack>
        <Text color="primary">Possuem estes tipos de atividades</Text>

        {filter.has_activities_types.length > 0 && (
          <HStack flexWrap="wrap">
            {filter.has_activities_types.map((name: string) => {
              return (
                <Tag bg="bgContainer" key={name} variant="filter-tags">
                  <TagLabel>{name}</TagLabel>
                </Tag>
              )
            })}
          </HStack>
        )}
      </Stack>

      <Divider />

      <Stack>
        <Text color="primary">Não possuem estes tipos de atividades</Text>

        {filter.not_has_activities_types.length > 0 && (
          <HStack flexWrap="wrap">
            {filter.not_has_activities_types.map((name: string) => {
              return (
                <Tag bg="bgContainer" key={name} variant="filter-tags">
                  <TagLabel>{name}</TagLabel>
                </Tag>
              )
            })}
          </HStack>
        )}
      </Stack>

      <RefreshButton mt={2} minWidth="100%" onClick={resetMetadataFilter} variant="outline">
        Limpar filtros
      </RefreshButton>
    </Stack>
  )
}

export default memo(FrequencieActivitiesTypesFilterTemplate)
